import { useEffect } from 'react';
import { useAuth } from '@/auth/store';
import { useTeam } from './store';

const POLL_MS = 30_000;

/** Load membership on sign-in; poll state every 30 s while visible (cheap: ETag → 304). */
export function useTeamPolling() {
  const status = useAuth((s) => s.status);
  const { load, refresh, reset, membership } = useTeam();
  useEffect(() => { if (status === 'signedIn') void load(); else if (status === 'signedOut') void reset(); }, [status, load, reset]);
  useEffect(() => {
    if (status !== 'signedIn' || !membership) return;
    const tick = () => { if (document.visibilityState === 'visible') void refresh(); };
    const id = setInterval(tick, POLL_MS);
    document.addEventListener('visibilitychange', tick);
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', tick); };
  }, [status, membership, refresh]);
}
